import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '../../alert/alert.service';
import { OverviewPriorityGroupDetailComponent } from './overview-priority-group-detail/overview-priority-group-detail.component';
import { ModalService } from '../../modal/modal.service';
import { OverviewPriorityGroupVinculateComponent } from './overview-priority-group-vinculate/overview-priority-group-vinculate.component';
import { DetailProjectService } from 'src/app/services/detail-project.service';

@Component({
  selector: 'fun-overview-priority-group-timeline',
  templateUrl: './overview-priority-group-timeline.component.html',
  styleUrls: ['./overview-priority-group-timeline.component.scss'],
})
export class OverviewPriorityGroupTimelineComponent implements OnInit {

  @Output() public bookInvestEvent = new EventEmitter<any>();
  @Input() public detailProject;

  constructor(
    private alertService: AlertService,
    private modalService: ModalService,
    private detailProjectService: DetailProjectService
  ) { }

  ngOnInit() { }

  public isStageActive(index: number): boolean {
    return this.detailProjectService.getIfIsStageActive(index, this.detailProject);
  }

  public isStagePassed(index: number): boolean {
    return this.detailProjectService.isStagePassed(index, this.detailProject);
  }

  public hasUserPriorityGroup(stage: any): boolean {
    return this.detailProjectService.hasUserPriorityGroup(stage);
  }

  viewDetails(stage) {
    const params = { stage };
    this.alertService.showModal(OverviewPriorityGroupDetailComponent, params, '', '', true).subscribe((modal: any) => {
      modal.activeCross().subscribe();
      modal.onClose().subscribe();
    });
  }

  vinculate(stage) {
    const params = { stage };
    this.modalService.showModal(OverviewPriorityGroupVinculateComponent, params, '', '', true).subscribe((modal: any) => {
      modal.onClose().subscribe();
      modal.getChildComponent().subscribe((componentRef: OverviewPriorityGroupVinculateComponent) => {
        componentRef.removeComponentEvent.subscribe(() => {
          modal.close();
        });
      });
    });
  }

  bookInvestment() {
    this.bookInvestEvent.emit();
  }

}
